import React from "react";
import styled from "styled-components";

const Wrap = styled.nav`
  margin: 16px 0 0;
  display: flex;
  justify-content: center;
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;

  max-width: 1100px;
  width: 100%;
`;

const Chip = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  padding: 10px 16px;
  border-radius: 999px;

  border: 1px solid #e5e7eb;
  background: #fff;
  color: #111827;

  font-weight: 950;
  text-decoration: none;
  cursor: pointer;

  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.06);
  transition: transform 140ms ease, background 140ms ease, box-shadow 140ms ease;

  &:hover {
    transform: translateY(-1px);
    background: #f9fafb;
    box-shadow: 0 16px 44px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0px);
  }

  &:focus-visible {
    outline: 2px solid rgba(15, 118, 110, 0.35);
    outline-offset: 3px;
  }
`;

const Hint = styled.div`
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
  color: #6b7280;
`;

const smoothScrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function QuickLinks({ items = [], showHint = false }) {
  if (!items.length) return null;

  return (
    <>
      <Wrap aria-label="Snabblänkar">
        <Chips>
          {items.map((it) => (
            <Chip
              key={it.id}
              href={`#${it.id}`}
              onClick={(e) => {
                e.preventDefault();
                smoothScrollToId(it.id);
              }}
            >
              {it.label}
            </Chip>
          ))}
        </Chips>
      </Wrap>

      {showHint ? <Hint>Tips: Snabblänkarna scrollar till sektionerna.</Hint> : null}
    </>
  );
}
